import { ApolloError } from '@apollo/client';
import React from 'react';
import { useParams } from 'react-router';
import styled from 'styled-components';
import { useSelfQuery } from '../../../graphql/types';
import { ZENDESK_SUBMIT_BUG_LINK } from '../../HomePage/Resources/constants';
import { Link } from '../Link';
import Text, { TextKind } from '../Text';

const Container = styled.div<{ $noMargin?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: ${({ $noMargin }) => ($noMargin ? '0' : '82px')};
  gap: 8px;
`;

type GenericErrorProps = {
  testId?: string;
  noMargin?: boolean;
  error?: ApolloError;
};

const GenericError: React.FC<GenericErrorProps> = ({
  testId,
  noMargin,
  error,
}) => {
  const { memberId } = useParams();
  const { data: selfData } = useSelfQuery();

  const selfId = selfData?.self?.id;
  const requestId = error?.graphQLErrors?.[0]?.extensions?.requestId;

  const supportUrl = new URL(ZENDESK_SUBMIT_BUG_LINK);

  if (memberId || selfId || requestId) {
    supportUrl.searchParams.append(
      'tf_description',
      '<br />' +
        '<br />' +
        '<br />' +
        '<pre>' +
        '<b>##### Auto-generated fields #####</b>' +
        '<br />' +
        (memberId ? `Member ID: ${memberId}<br />` : '') +
        (selfId ? `Coach ID: ${selfId}<br />` : '') +
        (requestId ? `Request ID: ${requestId}` : '') +
        '</ pre>',
    );
  }

  return (
    <Container
      {...(Boolean(testId) && { 'data-testid': testId })}
      $noMargin={noMargin}
    >
      <Text kind={TextKind.TitleXs} component="h2">
        Oh no, something went wrong!
      </Text>
      <Text
        kind={TextKind.BodyS}
        style={{
          lineHeight: 1.25,
        }}
      >
        Try refreshing the page. If error persists submit a ticket via{' '}
        <Link
          to={supportUrl.toString()}
          target="_blank"
          rel="noopener noreferrer"
          trackingData={{
            event_label: 'Zendesk Support',
          }}
        >
          Zendesk
        </Link>
      </Text>
    </Container>
  );
};

export default GenericError;
